import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/organizations/$orgId/edit")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/workspace/organizations/$orgId/edit",
      params: { orgId: params.orgId },
    });
  },
});
